function moveRecaptchaBadge() {
  const grecaptchaBadge = document.querySelector('.grecaptcha-badge');
  if (grecaptchaBadge) {
    const badgeContainer = document.querySelector('.grecaptcha-container');
    return badgeContainer.appendChild(grecaptchaBadge);
  }
  return false;
}

export default moveRecaptchaBadge;
